<template>
  <div>
    <PostStart :is-page="true" />
  </div>
</template>
<script>
import PostStart from '@/components/organisms/PostStart'

export default {
  name: 'PostStartPage',

  components: {
    PostStart,
  },

  data() {
    return {}
  },

  methods: {},
}
</script>
